import { getSessionPlayer } from '../../commons/getSessionPlayerRequire';
import type { LegacyElement, W3CElement } from 'src/utils';
import type { StepActionUtils } from '../utils/stepActionUtils';
import type { FrameHandler } from 'clickim/src/locators/dynamicParentUtils';
import type { IExecutionResult } from 'clickim/src/common/playback/stepPlayers/stepPlayback';
import type { ISerializedStep, Step } from 'clickim/src/common/models/step';
import type { PlaybackContext, RunOrPlaybackContext, Target } from 'clickim/src/background/playbackContext';

export type RunContext = ReturnType<PlaybackContext['getRunContext']>;
export interface SeleniumTarget extends Target { seleniumElement: W3CElement | LegacyElement }
export class StepAction<S extends Step = Step, TContext extends RunOrPlaybackContext = PlaybackContext> {
    protected readonly frameId: number | undefined = 0;

    constructor(
        protected readonly step: ISerializedStep<S>,
        protected readonly context: TContext,
        // Frame handler can be null for steps with ignoreTopFrame
        protected readonly frameHandler: FrameHandler | null,
        protected readonly exportsGlobal = {},
        protected readonly stepActionUtils: StepActionUtils = undefined!,
        protected readonly locateElementPlayer = undefined,
        protected readonly exportsTest = {},
    ) {}

    protected get driver() {
        if (this.context.project.defaults?.ignoreVisibilityForExisting && !this.stepActionUtils.driver.getIgnoreVisibility()) {
            this.stepActionUtils.driver.setIgnoreVisibility(true);
        }
        return this.stepActionUtils.driver;
    }

    protected get sessionPlayerInit() {
        return getSessionPlayer();
    }

    protected async performAction(): Promise<any> {
        throw new Error('not implemented');
    }

    protected getTarget() {
        const targetId = this.step.targetId || 'targetId';
        return this.context.data[targetId] as SeleniumTarget;
    }

    public async execute(): Promise<IExecutionResult> {
        try {
            const res = await this.performAction();
            return { success: true, ...res };
        } catch (err) {
            const errorMsg = err?.message;
            const displayMsg = err?.displayMessage;
            return {
                success: false,
                reason: errorMsg,
                exception: err,
                errorType: this.sessionPlayerInit.commonConstants.stepResult.ACTION_EXCEPTION,
                resultInfo: {
                    exception: `selenium exception: ${errorMsg}`,
                    // clickim -> playbackStepResultHandler.js -> FAILURE_REASON_MAPPING -> ACTION_EXCEPTION
                    // expects resultInfo.error or resultInfo.reason
                    error: displayMsg || errorMsg,
                },
            };
        }
    }
}
